import { Brand, make } from 'shared/types/brand';

export type SignedUrl = Brand<string, 'SignedUrl'>;
export type ImageSignedUrl = Brand<string, 'ImageSignedUrl'>;
export type DrawingSignedUrl = Brand<string, 'DrawingSignedUrl'>;
export type MergedSignedUrl = Brand<string, 'MergedSignedUrl'>;
export type ThumbnailSignedUrl = Brand<string, 'ThumbnailSignedUrl'>;
export type MergedThumbnailSignedUrl = Brand<
  string,
  'MergedThumbnailSignedUrl'
>;

export const SignedUrl = make<SignedUrl>();
export const ImageSignedUrl = make<ImageSignedUrl>();
export const DrawingSignedUrl = make<DrawingSignedUrl>();
export const MergedSignedUrl = make<MergedSignedUrl>();
export const ThumbnailSignedUrl = make<ThumbnailSignedUrl>();
export const MergedThumbnailSignedUrl = make<MergedThumbnailSignedUrl>();
